import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

import { Formik } from 'formik';

import { LIST } from '~/modules/customFieldTypes';
import { getValidationSchema } from '~/modules/getCustomFieldValidationSchema';

import StickyAlertContext from '~/containers/StickyAlertManager/StickyAlertContext';

import ModalWrapper from './ModalWrapper';

class ExecuteActionModal extends React.Component {
    constructor(props) {
        super(props);
        this.fieldPrefix = 'field__';
        this.formRef = createRef();
        this.resetActionFields();
    }
    resetActionFields = () => {
        this.state = {
            actionFields: [],
            actionFieldsByResource: []
        };
    };
    render() {
        const fieldsForValidation = {
            actionType: {
                required: true,
                type: LIST,
                internalName: 'actionType'
            },
            action: {
                required: true,
                type: LIST,
                internalName: 'action'
            },
            resource: {
                type: LIST,
                internalName: 'resource'
            }
        };
        this.state.actionFieldsByResource?.forEach(field => {
            const key = this.fieldPrefix + field.id;
            const value = {
                ...field,
                required: field.required || field.isRequired
            };
            // console.log({ key, value });
            fieldsForValidation[key] = value;
        });
        const validationSchema = getValidationSchema(fieldsForValidation);
        // console.log({ fieldsForValidation, validationSchema });

        return (
            <StickyAlertContext.Consumer>
                {stickyAlert => {
                    return (
                        <Modal
                            centered
                            scrollable
                            size="md"
                            show={this.props.show}
                            onHide={this.props.onHide}
                            aria-labelledby="ExecuteActionModal"
                            dialogClassName="fixed-height"
                            id="ExecuteActionModal"
                        >
                            <Formik
                                initialValues={this.props.initialValue}
                                validationSchema={validationSchema}
                                innerRef={this.formRef}
                                onSubmit={() => {}}
                            >
                                {formProps => {
                                    return (
                                        <ModalWrapper
                                            section="objects"
                                            isInEditMode={false}
                                            stickyAlert={stickyAlert}
                                            formProps={formProps}
                                            values={formProps.values}
                                            setValues={formProps.setValues}
                                            fieldPrefix={this.fieldPrefix} //check whether it is mandatory or not
                                            isBulk={this.props.isBulk}
                                            object={this.props.object}
                                            triage={this.props.triage}
                                            tokenList={this.props.tokenList}
                                            actionList={this.props.actionList} //refactor not mandatory
                                            executeAction={
                                                this.props.executeAction
                                            }
                                            disableChangeAction={
                                                this.props.disableChangeAction
                                            }
                                            fromContextualMenu={
                                                this.props.fromContextualMenu
                                            }
                                            onRunActionSubmit={
                                                this.props.onRunActionSubmit
                                            }
                                            actionFields={
                                                this.state.actionFields
                                            }
                                            actionFieldsByResource={
                                                this.state
                                                    .actionFieldsByResource
                                            }
                                            setActionFields={(
                                                newActionFields,
                                                mappingKey,
                                                callback
                                            ) => {
                                                // console.trace({ newActionFields });
                                                this.setState(
                                                    {
                                                        actionFields:
                                                            newActionFields
                                                    },
                                                    callback || null
                                                );
                                            }}
                                            setActionFieldsByResource={newActionFieldsByResource => {
                                                this.setState({
                                                    actionFieldsByResource:
                                                        newActionFieldsByResource
                                                });
                                            }}
                                            onHide={() => {
                                                this.resetActionFields();
                                                this.props.onHide?.();
                                            }}
                                        />
                                    );
                                }}
                            </Formik>
                        </Modal>
                    );
                }}
            </StickyAlertContext.Consumer>
        );
    }
}

ExecuteActionModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    actionList: PropTypes.object,
    object: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    executeAction: PropTypes.func,
    triage: PropTypes.object,
    disableChangeAction: PropTypes.bool,
    initialValue: PropTypes.object,
    tokenList: PropTypes.object,
    isBulk: PropTypes.bool,
    fromContextualMenu: PropTypes.bool,
    onRunActionSubmit: PropTypes.func
};

ExecuteActionModal.defaultProps = {
    initialValue: {},
    triage: null,
    disableChangeAction: false,
    isBulk: false,
    fromContextualMenu: false,
    onRunActionSubmit: () => {}
};

export default ExecuteActionModal;
